import { render, staticRenderFns } from "./inspectionTable.vue?vue&type=template&id=c61dc294"
import script from "./inspectionTable.vue?vue&type=script&lang=js"
export * from "./inspectionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports